function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useCallback, useState } from "react";
import { createCtx } from "../../utils/createCtx";
var ref = _slicedToArray(createCtx(), 3), useZIndexContext = ref[0], ZIndexContextProvider = ref[1], ZIndexContext = ref[2];
var ZIndexConsumer = ZIndexContext.Consumer;
var zIndices = {
    base: 0,
    panel: 400,
    fullscreen: 800,
    modal: 1200
};
var POPPER_ZINDEX = 100;
var SCRIM_ZINDEX = -100;
var getZIndex = function(kind) {
    return zIndices[kind];
};
var getPopperZIndexBase = function(zIndex) {
    return zIndex + POPPER_ZINDEX;
};
var getScrimZIndexBase = function(zIndex) {
    return zIndex + SCRIM_ZINDEX;
};
var initialState = {
    kind: 'base',
    isBase: false,
    isPanel: false,
    isModal: false,
    isFullscreen: false,
    zIndex: 0
};
var updateState = function(state) {
    return _objectSpread({}, state, {
        isBase: state.kind === 'base',
        isFullscreen: state.kind === 'fullscreen',
        isModal: state.kind === 'modal',
        isPanel: state.kind === 'panel',
        zIndex: getZIndex(state.kind)
    });
};
var ZIndexProvider = function(param) {
    var tmp = param.kind, initialKind = tmp === void 0 ? 'base' : tmp, children = param.children;
    var ref1 = _slicedToArray(useState(function() {
        return updateState(_objectSpread({}, initialState, {
            kind: initialKind
        }));
    }), 2), state = ref1[0], setState = ref1[1];
    var setKind = function(kind) {
        return setState(function(prev) {
            return updateState(_objectSpread({}, prev, {
                kind: kind
            }));
        });
    };
    var getPopperZIndex = useCallback(function() {
        return getPopperZIndexBase(state.zIndex);
    }, [
        state.zIndex
    ]);
    var getScrimZIndex = useCallback(function() {
        return getScrimZIndexBase(state.zIndex);
    }, [
        state.zIndex
    ]);
    return _jsx(ZIndexContextProvider, {
        value: _objectSpread({}, state, {
            setKind: setKind,
            getPopperZIndex: getPopperZIndex,
            getScrimZIndex: getScrimZIndex
        }),
        children: children
    });
};
export { POPPER_ZINDEX, SCRIM_ZINDEX, ZIndexConsumer, ZIndexContext, ZIndexProvider, getPopperZIndexBase as getPopperZIndex, getScrimZIndexBase as getScrimZIndex, getZIndex, useZIndexContext };
export default ZIndexProvider;
